import { FileTypes } from './../enums/file-types';
import {DocumentExtensions as documentExtensions} from '../constants/file-extensions';
import { audioExtensions } from '../constants/audio-extensions';
import { videoExtensions } from '../constants/video-extensions';
import { imageExtensions } from '../constants/image-extensions';

export class FileHelper {
  public static getAllowedAttachments = ():string => {
    const combinedArray = [
      ...audioExtensions.map(i => `.${i}`),
      ...videoExtensions.map(i => `.${i}`),
      ...imageExtensions.map(i => `.${i}`),
      ...documentExtensions.map(i => `.${i}`)
    ]
    return combinedArray.join(',');
  }

  public static getFileType = (filePath: string): FileTypes => {
    const lastIndexOf = filePath.lastIndexOf(".");
    const fileExtension = filePath.substring(lastIndexOf+1).toLocaleLowerCase();
    if(imageExtensions.find(x => x === fileExtension)){
      return FileTypes.Image
    }
    if(videoExtensions.find(x => x === fileExtension)){
      return FileTypes.Video
    }
    if(audioExtensions.find(x => x === fileExtension)){
      return FileTypes.Audio
    }
    if(documentExtensions.find(x => x === fileExtension)){
      return FileTypes.Document
    }
    return FileTypes.CVS;
  }

  public static getExtensionsByFileType = (fileType: FileTypes):string => {
    if(fileType === FileTypes.Image) {
      return imageExtensions.map(i => `.${i}`).join(',');
    } else
    if(fileType === FileTypes.Video) {
      return videoExtensions.map(i => `.${i}`).join(',');
    } else
    if(fileType === FileTypes.Audio) {
      return audioExtensions.map(i => `.${i}`).join(',');
    } else
    if(fileType === FileTypes.Document) {
      return documentExtensions.map(i => `.${i}`).join(',');
    } else {
      return FileHelper.getAllowedAttachments();
    }
  }

  public static convertBase64ToFile = (imageBase64: string, fileName: string, fileType: string): File => {
    const arr = imageBase64.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: fileType });
  }
}
